import React from 'react';
import * as H from 'history';
import { DefaultRequest } from '../requests/default.request';
import Store from '../redux/store';
import img from '../assets/start.png';
import { WebsocketClient } from '../websocket/module';
import '../resources/css/start.page.css';
import { TableStatusEventObject } from '../websocket/type';
import { createHashHistory } from 'history';
import ShoppingCart from '../modules/shopping-cart';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import _ from 'lodash';
// import { Dialog, DialogTitle, DialogActions, Button, Checkbox } from '@material-ui/core';
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
// import i18nService from '../i18n';
import CryptoJS from 'crypto-js'
import { getSettingInfo } from '../tools/get-setting-info';
import { TableStatus } from '../constants/type.constant';
import { getSeverAndLoacalDiff } from '../tools/local-moment';


class StartPage extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.state = {
            openDialog: true,

            // 勾选提示框是否显示
            isTipsChecked: false,
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    UNSAFE_componentWillMount() {
        // 根据桌台id获取当前桌台状态
        this.getTableStatus();
        WebsocketClient.addListener('TABLE_STATUS', this.tableStatusListener);
        this.initDishRules()
    }
    async componentDidMount() {

        // DefaultRequest.updateOrdersStatus([
        //     {
        //         order_head_id: 3147,
        //         select_menu: '',
        //         customer_num: '',
        //         child_number: '',
        //         other_number: '',
        //         adult_number: '',
        //     }
        // ])

        // $ 接收 其他顾客发送的桌台状态通知 ,
        if (StateManager.getFromCache('languageStatus')) { }
    }
    componentWillUnmount() {
        WebsocketClient.removeListener('TABLE_STATUS', this.tableStatusListener)
    }

    // *********************
    // 方法区
    // *********************

    /**
     *  $ 监听通讯事件
     */
    // 监听桌台状态通知
    public tableStatusListener = (data: TableStatusEventObject) => {
        const { orderRequestMsg, resendOrderSecond } = data;
        // 开台请求的信息
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderRequestMsg',
            value: orderRequestMsg
        })
        // 总人数
        const totalNum = orderRequestMsg.childNum + orderRequestMsg.adultNum + Number(orderRequestMsg.otherNum);
        // 开台信息
        console.log('start-开台信息orderRequestMsg:', orderRequestMsg);
        const autonomous = _.find(Store.getState().settingInfo, ['name', 'rule-autonomous-meal']);
        const autonomousStatus = _.get(autonomous, `value.status`)
        if (autonomousStatus) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab',
                value: {
                    person: orderRequestMsg.person || totalNum,
                    orderId: data.orderTab.orderId,
                    menuList: orderRequestMsg.menu,
                    customer: Store.getState().orderTab.customer,
                    childNum: orderRequestMsg.childNum,
                    otherNum: orderRequestMsg.otherNum,
                    normalNum: orderRequestMsg.adultNum,
                }
            })
        } else {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab',
                value: {
                    person: orderRequestMsg.person || totalNum,
                    orderId: data.orderTab.orderId,
                    menuList: orderRequestMsg.menu,
                    customer: Store.getState().orderTab.customer ? Store.getState().orderTab.customer : 1,
                    childNum: orderRequestMsg.childNum,
                    otherNum: orderRequestMsg.otherNum,
                    normalNum: orderRequestMsg.adultNum,
                }
            })
        }
        // 重新发送按钮倒计时
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'resendOrderSecond',
            value: resendOrderSecond,
        })
        createHashHistory().push({ pathname: '/Main' });
    }

    // 根据桌台id获取当前桌台状态
    getTableStatus = async () => {
        try {
            let { search, pathname } = this.props.location;
            // 获取api系统设置
            let _settingInfo = await DefaultRequest.getSettingInfo();
            // 地址是否需要解密
            const isEncrypting = getSettingInfo('is_encrypting', 'value', _settingInfo) || 0;
            // $ 区分精简版和普通版
            if (pathname === '/lite/' || pathname === '/lite') {
                // 直接跳转到精简版模式
                createHashHistory().push({ pathname: '/LiteHome' });
            }
            else if (search.length > 0 && search.split('?table_id=').length > 1) {
                // 获取服务器与本地时间戳差值
                const diffTimeStamp = await getSeverAndLoacalDiff();
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'diffTimeStamp',
                    value: diffTimeStamp,
                })
                let tableId = search.split('?table_id=')[1].split('&')[0];
                //  CryptoJS 解密
                if (process.env?.REACT_APP_IS_decrypt !== 'dev' && isEncrypting) {
                    const bytes = CryptoJS.AES.decrypt(tableId, 'TableID');
                    tableId = bytes.toString(CryptoJS.enc.Utf8);
                }
                let result = await DefaultRequest.getTableSById(parseInt(tableId));
                let tableStatus: TableStatus = result[0];
                // 判断该桌是否为合并桌
                if (result[0].merge_status) {
                    const mergeTargetTableId = _.get(result[0], 'merge_target_table.table_id');
                    if (mergeTargetTableId) {
                        const mergeTargetRes = await DefaultRequest.getTableSById(parseInt(mergeTargetTableId));
                        tableStatus = mergeTargetRes[0];
                    }
                }
                const { table_id, cor_status, table_status, select_menu, table_name, order_head_id, customer_num, child_number, adult_number, other_number } = tableStatus;
                // 当前扫码时间戳存入缓存
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'qrCodeDate',
                    value: Number(new Date())
                })
                // 当前桌台状态存入缓存
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableStatusById',
                    value: [tableStatus],
                })
                WebsocketClient.joinOrder(parseInt(`${table_id}`));
                // $ 初始化 购物车
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'shoppingCart',
                    value: {}
                })
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'liteMode',
                    value: false
                })
                /**
                 * table_status 0/null/1 未开台 6禁用 -1外卖单
                 * cor_status 审核状态： 0 审核中 1审核通过
                 * select_menu 选中的菜单
                 */
                // 桌台

                if (table_status !== 6) {
                    // 初始化房间
                    WebsocketClient.emitOrderClients({
                        event: 'MODIFY_DISH',
                        customer: Store.getState().orderTab.customer,
                        // dish: Store.getState().shoppingCart,
                        dish: {}
                    })
                    // 桌台id
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'tableId',
                        value: parseInt(`${table_id}`),
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'tableName',
                        value: table_name,
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.tableId',
                        value: parseInt(`${table_id}`)
                    })
                }
                // 跳转首页
                if (table_status === null || table_status === 0 || table_status === 1) {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.orderId',
                        value: 0
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'isOpenTab',
                        value: false
                    })
                    ShoppingCart.metaData = {};
                    ShoppingCart.globalRound = 1;
                    Store.dispatch({
                        type: 'SYNCHRONIZE',
                        direction: 'STATE_TO_CACHING',
                    })
                    createHashHistory().push({ pathname: '/Home' });
                } else if (table_status === 3 || table_status === 2 || table_status === 4) {
                    // 跳转菜单页
                    // 底部导航菜单页面
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'viewPage',
                        value: 'menuPage',
                    });

                    // 人数
                    if (customer_num) {
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.person',
                            value: customer_num,
                        });
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.childNum',
                            value: child_number,
                        });
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.otherNum',
                            value: other_number,
                        });
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.normalNum',
                            value: adult_number,
                        });
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderRequestMsg.adultNum',
                            value: adult_number
                        })
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderRequestMsg.childNum',
                            value: child_number
                        })
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderRequestMsg.otherNum',
                            value: other_number
                        })
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderRequestMsg.person',
                            value: customer_num
                        })
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'shoppingCart',
                            value: {}
                        })
                    }
                    // 菜单id
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderTab.menuList.main_group_id',
                        value: select_menu ? parseInt(select_menu) : ''
                    })
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'orderRequestMsg.menu.main_group_id',
                        value: select_menu ? parseInt(select_menu) : ''
                    })
                    // 订单id
                    if (order_head_id) {
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.orderId',
                            value: order_head_id,
                        });
                        // 获取自动生成的客户名称
                        await this.getGenerateCustomerName(order_head_id)
                    }

                    if (cor_status === 0) {

                        // 弹出审核中
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'approvalStatus',
                            value: 'REVIEW',
                        })
                        Store.dispatch({
                            type: 'SET_CACHING',
                            path: 'orderTab.customer',
                            value: ''
                        })
                    } else if (cor_status === 1) {
                        // table_status = 4 为已打预结单状态
                        if (table_status === 3 || table_status === 2 || table_status === 4) {
                            // 审核通过
                            Store.dispatch({
                                type: 'SET_CACHING',
                                path: 'approvalStatus',
                                value: 'NO',
                            })
                            // 记录聚客开桌状态
                            Store.dispatch({
                                type: 'SET_CACHING',
                                path: 'tableStatus',
                                value: true,
                            })
                        } else {
                            // 审核未通过
                            Store.dispatch({
                                type: 'SET_CACHING',
                                path: 'approvalStatus',
                                value: 'REVIEW',
                            })
                        }
                    }
                    // 客户首屏选择
                    const customerFirstScreen = getSettingInfo('customer-first-screen', 'value');
                    if (customerFirstScreen === 1) {
                        createHashHistory().push({ pathname: '/Main' });
                    }
                    else {
                        createHashHistory().push({ pathname: '/Home' });
                    }
                    // customer_num ? createHashHistory().push({ pathname: '/Main' }) : createHashHistory().push({ pathname: '/Home' });
                } else {
                    this.messengerModule.say({
                        message: `${i18n.t('home_page_text_table_pause_use')}`,
                        level: "Error",
                    });
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    /**
     * 获取自动生成的客户名称
     */

    public async getGenerateCustomerName(orderId: number) {
        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            const autonomous = _.find(settingInfo, ['name', 'rule-autonomous-meal']);
            const autonomousStatus = _.get(autonomous, `value.status`)
            // 轮次是否开启
            const openTurn = settingInfo[1].value ? settingInfo[1].value.enable : '';
            // 是否开启自主点餐模式
            if (autonomousStatus) {
                // 自主 多个顾客id
                let result = await DefaultRequest.getGenerateCustomerName(orderId)
                let customer = result.now_customer_name ? result.now_customer_name.toString() : ''

                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.customer',
                    value: customer
                })

            } else {
                // 非自主 一个顾客id
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'orderTab.customer',
                    value: '1'
                })

            }
            // 关闭轮次功能，将菜品都放进为0的购物车内
            if (!openTurn) ShoppingCart.globalRound = 0;
        }
        catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('general_text_can_not_get_rules_of_dish')}`,
                level: "Error"
            })
        }

    }

    // $ 初始化菜品相关规则
    public async initDishRules() {
        // 菜品基础规则参数
        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
            // 点餐最大回合数
            ShoppingCart.globalRoundMax = settingInfo[3].value

        } catch (error) {
            console.log(error);
        }
    }

    // $ 菜品添加提示弹窗
    public addedTipsHandleChange = (event: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
        this.setState({ isTipsChecked: event.target.checked })
    };
    // *********************
    // 视图区
    // *********************


    render() {
        // const { openDialog, isTipsChecked } = this.state;
        return (
            <div className="start">
                <div className="top">
                    <div className="logo">
                        <img src={img} alt="qop" width="65" />
                    </div>
                    <div>QOP</div>
                </div>

                <div className="footer">2020 MAIN TANK SRL. ALL RIGHTS RESERVED</div>
            </div>
        )
    }
}

export default withSnackbar(StartPage)

type Props = {
    location: H.Location
    history: H.History
} & WithSnackbarProps

type State = {
    openDialog: boolean;
    isTipsChecked: boolean;
}
